import { useEffect } from 'react';

const usePageTitle = (title) => {
  useEffect(() => {
    const base = 'ElevateMN';
    document.title = title ? `${title} | ${base}` : `${base} | Mental Health & Community Support`;
    return () => { document.title = `${base} | Mental Health & Community Support`; };
  }, [title]);
};

export default usePageTitle;
